import { render } from "./EditDonorInformationPage.vue?vue&type=template&id=2ed1dee8"
import script from "./EditDonorInformationPage.vue?vue&type=script&lang=js"
export * from "./EditDonorInformationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__